import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { IMG, LOGO_URL } from "@/data";

export default function Nav({ view, navTo, onSearch, onDrawer, savedCount, night, onToggleNight }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { id: "hat", label: "রঙের হাট", short: "হাট", testid: "nav-link-haat" },
    { id: "moncho", label: "রং ও মঞ্চ", short: "মঞ্চ", testid: "nav-link-moncho" },
  ];

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div
        className={`flex items-center justify-between px-4 py-3 transition-all duration-500 sm:px-8 ${
          scrolled
            ? "border-b border-gold/15 bg-dusk/80 backdrop-blur-md"
            : "bg-gradient-to-b from-dusk/70 to-transparent"
        }`}
      >
        <button
          data-testid="nav-link-home"
          onClick={() => navTo("gate", "গ্রাম-প্রবেশ")}
          className="group flex items-center gap-2.5"
        >
          <span
            data-testid="header-logo"
            className="flex h-10 items-center rounded-lg border border-gold/25 bg-alpana px-1.5 shadow-[0_2px_14px_rgba(0,0,0,0.45)] transition-transform duration-500 group-hover:scale-105"
          >
            <img src={LOGO_URL} alt="রং ও মাটি" className="h-8 w-auto object-contain no-night" data-testid="brand-logo" />
          </span>
          <span className="font-display text-lg leading-none text-alpana transition-colors duration-300 group-hover:text-gold">
            রং ও মাটি
          </span>
        </button>

        <nav className="flex items-center gap-1 sm:gap-2">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => navTo(l.id, l.label)}
              className={`rounded-full px-3 py-1.5 text-sm transition-all duration-300 sm:px-4 ${
                view === l.id
                  ? "bg-gold/15 text-gold"
                  : "text-sand/80 hover:bg-sand/10 hover:text-sand"
              }`}
            >
              <span className="hidden sm:inline">{l.label}</span>
              <span className="sm:hidden">{l.short}</span>
            </button>
          ))}

          <button
            data-testid="night-toggle"
            onClick={onToggleNight}
            aria-label={night ? "দিনে ফিরে যান" : "প্রদীপের আলোয় সন্ধ্যা নামান"}
            className="ml-1 rounded-full p-2 text-sand/80 transition-all hover:bg-sand/10 hover:text-gold"
          >
            {night ? (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="4.5" />
                <path d="M12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M18.7 5.3l-1.8 1.8M7.1 16.9l-1.8 1.8" />
              </svg>
            ) : (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5a8.5 8.5 0 1 0 11 11Z" />
              </svg>
            )}
          </button>

          <button
            data-testid="nav-button-search"
            onClick={onSearch}
            aria-label="সন্ধান"
            className="rounded-full p-2 text-sand/80 transition-all hover:bg-sand/10 hover:text-gold"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
              <circle cx="11" cy="11" r="7" />
              <path d="m20 20-3.5-3.5" />
            </svg>
          </button>

          <button
            data-testid="nav-button-cart"
            onClick={onDrawer}
            aria-label="সংরক্ষিত পণ্য"
            className="relative rounded-full p-2 text-sand/80 transition-all hover:bg-sand/10 hover:text-gold"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 8h12l-1 12H7L6 8Z" />
              <path d="M9 8V6a3 3 0 0 1 6 0v2" />
            </svg>
            {savedCount > 0 && (
              <span
                data-testid="nav-cart-count"
                className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-vermilion px-1 text-[10px] font-semibold text-alpana"
              >
                {savedCount}
              </span>
            )}
          </button>
        </nav>
      </div>
    </header>
  );
}
